import React, { useState } from 'react'
import api from '@/services/api'
const useCreateCategory = () => {
    const [loading, setLoading] = useState(false)

    const create = async (categoryName, parentId = 0, genericArticleId) => {
        try {
            setLoading(true)
            const { data } = await api(true).post('/webshop/management/tecdoc-menu-create-category', {
                category: categoryName,
                parentId,
                genericArticleId
            })
         
            return data
        }catch (error) {
            throw error
        } finally {
            setLoading(false)
        }
    }



    return { loading, create }
}

export default useCreateCategory